import { Component, inject } from '@angular/core';
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';
import { animationsPop, animationsOnHeight, animationsSlideInOut } from './animations';

@Component({
  selector: 'notyf-toast-component',
  templateUrl: './toast.component.html',
  animations: [animationsPop],
  preserveWhitespaces: false,
  standalone: false,
})
export class ToastComponent extends Toast {
  protected toastrService: ToastrService;
  toastPackage: ToastPackage;

  constructor() {
    const toastrService = inject(ToastrService);
    const toastPackage = inject(ToastPackage);

    super(toastrService, toastPackage);

    this.toastrService = toastrService;
    this.toastPackage = toastPackage;
  }
}
